// @flow

import styled from 'styled-components';

import typeof TTheme from '../theme';

type TP = { theme: TTheme };

export const P = styled.p`
  color: ${({ theme }: TP) => theme.colors.dark};
  font-size: ${({ theme }: TP) => theme.typography.size.standard};
  line-height: 1.5;
`;

export const Centered = styled(P)`text-align: center;`;

export const Flex = styled.div`
  display: flex;
  ${props => (props.flex ? `flex: ${props.flex};` : '')};
  ${props =>
    props.flexDirection ? `flex-direction: ${props.flexDirection};` : ''};
  ${props => (props.flexWrap ? `flex-wrap: ${props.flexWrap};` : '')};
  ${props =>
    props.justifyContent ? `justify-content: ${props.justifyContent};` : ''};
`;

export const SimpleFlex = styled.div`flex: ${props => props.flex};`;

export const Spacer = styled.div`
  width: ${(props: TP) => props.theme.spacing.standard};
`;



// WEBPACK FOOTER //
// ./src/components/index.js